import _ from "lodash/fp";
import React from "react";
import {Button, ControlLabel, FormControl, FormGroup, Modal} from "react-bootstrap";
import {Consumer} from "../CreateSigntask";
import {connect} from "react-redux";
import {createTemplate} from "../../../stores/templates/createTemplate";

const CreateTemplate = connect(
  null,
  dispatch => ({
    createTemplate: _.compose(dispatch, createTemplate)
  }),
  null,
  { withRef: true }
)(class extends React.Component {
  state = {
    name: "",
    show: false
  };

  show = () => this.setState({show: true});
  dismiss = () => this.setState({show: false});
  updateName = event => this.setState({name: event.target.value});
  save = () => {
    const data = _(this.props.getData())
      .set("name", this.state.name)
      .omit(["reference"])
      .value();

    this.props.createTemplate(data);
    this.dismiss();
  };

  render = () => (
    <Modal show={this.state.show} onHide={this.dismiss}>
      <Modal.Header closeButton>
        <Modal.Title>Saving template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup>
          <ControlLabel>Template name</ControlLabel>
          <FormControl type="text" value={this.state.name} onChange={this.updateName} />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.dismiss}>Close</Button>
        <Button bsStyle="primary" onClick={this.save}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
});

export default class extends React.Component {
  component = React.createRef();
  show = () => this.component.current.getWrappedInstance().show();
  render = () => (
    <Consumer>{({getData}) => (
      <CreateTemplate ref={this.component} {...this.props} getData={getData} />
    )}</Consumer>
  );
}